/* eslint-disable no-sequences */
// on some search verticals, we use a querystring-based scheme
// in the URL hash to activate certain components, such as filters and expanded image details
// this module exports functions to get/set/delete the params stored with this method

export const getHashParams = () => new URLSearchParams(window.location.hash.replace('#', ''));
export const updateHashParams = (params) => {
  // this ensures the page doesn't try to jump to an element when the hash changes
  // https://stackoverflow.com/a/14690177
  window.history.replaceState(null, null, `#${params.toString()}`);
};

const withParams = (operation) => (...args) => operation(getHashParams(), ...args);
const withUpdate = (operation) => (...args) => updateHashParams(withParams(operation)(...args));

const getParam = (params, key) => params.get(key);
// using the sequence expressions here to ensure
// the URLSearchParams are returned when setting/deleting
export const setParam = (params, key, value) => (params.set(key, value), params);
const deleteParam = (params, key) => (params.delete(key), params);

export const FILTERS_KEY = 'f';
export const IMAGE_ID_KEY = 'id';
export const getHashParam = withParams(getParam);
export const setHashParam = withUpdate(setParam);
export const deleteHashParam = withUpdate(deleteParam);

export const getImageUrlHash = (id) => (
  setParam(new URLSearchParams(), IMAGE_ID_KEY, id).toString()
);
